/* Nos offres (bloc mr-offers, v1) — JS déporté en asset pour alléger l'éditeur de thème.
   Ajouts vs version inline : garde Shopify.designMode sur le timer (plus de fuite d'interval
   dans l'éditeur) + registre window.mroTimersV1 + init limitée aux blocs data-mro-root="v1". */
(function () {
  'use strict';

  var DESIGN_MODE = !!(window.Shopify && window.Shopify.designMode);

  function startCountdown(root) {
    var el = root.querySelector('[data-mro-countdown]');
    if (!el) return;
    var hours = parseInt(root.getAttribute('data-timer-hours'), 10) || 24;
    var key = 'mro_deadline_' + root.id;
    var hkey = 'mro_hours_' + root.id;
    var storedHours = parseInt(localStorage.getItem(hkey), 10);
    var deadline = parseInt(localStorage.getItem(key), 10);
    var now = Date.now();
    if (!deadline || isNaN(deadline) || deadline <= now || storedHours !== hours) {
      deadline = now + hours * 3600 * 1000;
      try { localStorage.setItem(key, String(deadline)); localStorage.setItem(hkey, String(hours)); } catch (e) {}
    }
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var diff = deadline - Date.now();
      if (diff <= 0) {
        deadline = Date.now() + hours * 3600 * 1000;
        try { localStorage.setItem(key, String(deadline)); } catch (e) {}
        diff = deadline - Date.now();
      }
      var t = Math.floor(diff / 1000);
      el.textContent = pad(Math.floor(t / 3600)) + ':' + pad(Math.floor((t % 3600) / 60)) + ':' + pad(t % 60);
    }
    tick();
    window.mroTimersV1 = window.mroTimersV1 || {};
    if (window.mroTimersV1[root.id]) clearInterval(window.mroTimersV1[root.id]);
    if (DESIGN_MODE) return;
    window.mroTimersV1[root.id] = setInterval(tick, 1000);
  }

  function buildItems(checked) {
    var items = [];
    var fixed = checked.getAttribute('data-mro-fixed') || '';
    fixed.split(',').forEach(function (pair) {
      if (!pair) return;
      var parts = pair.split(':');
      var id = parseInt(parts[0], 10);
      var qty = parseInt(parts[1], 10) || 1;
      if (id) items.push({ id: id, quantity: qty });
    });
    var wrap = checked.closest('.mro__offer-wrap');
    var groups = wrap ? wrap.querySelectorAll('.mro__variants') : [];
    for (var i = 0; i < groups.length; i++) {
      var qty = parseInt(groups[i].getAttribute('data-mro-vqty'), 10) || 1;
      var sel = groups[i].querySelector('input:checked');
      if (!sel) return { error: 'Cette taille est en rupture de stock. Choisissez-en une autre.' };
      var vid = parseInt(sel.value, 10);
      if (vid) items.push({ id: vid, quantity: qty });
    }
    var perso = wrap ? wrap.querySelector('.mro__perso') : null;
    if (perso) {
      var yes = perso.querySelector('[data-mro-perso-yes]');
      if (yes && yes.checked) {
        var iniEl = perso.querySelector('[data-mro-perso-initiale]');
        var ini = iniEl ? iniEl.value.trim() : '';
        if (!ini) return { error: 'Merci d\'indiquer l\'initiale à graver sur le collier.' };
        var pvid = parseInt(perso.getAttribute('data-mro-perso-vid'), 10);
        var pqty = parseInt(perso.getAttribute('data-mro-perso-qty'), 10) || 1;
        if (pvid) items.push({ id: pvid, quantity: pqty, properties: { 'Initiale collier': ini } });
      }
    }

    // Duo : UN seul pack (1 ligne, quantité 1) avec les infos de chaque médaille
    var dual = wrap ? wrap.querySelector('[data-mro-dual]') : null;
    if (dual) {
      var dvid = parseInt(dual.getAttribute('data-mro-dual-vid'), 10);
      var meds = dual.querySelectorAll('.mro__dual-med');
      var dprops = {};
      for (var d = 0; d < meds.length; d++) {
        var nomEl = meds[d].querySelector('[data-mro-dual-nom]');
        var telEl = meds[d].querySelector('[data-mro-dual-tel]');
        var dnom = nomEl ? nomEl.value.trim() : '';
        var dtel = telEl ? telEl.value.trim() : '';
        if (!dnom || !dtel) return { error: 'Merci de remplir le prénom et le téléphone de chaque médaille.' };
        dprops['Médaille ' + (d + 1) + ' - Prénom'] = dnom;
        dprops['Médaille ' + (d + 1) + ' - Téléphone'] = dtel;
      }
      if (dvid && meds.length) items.push({ id: dvid, quantity: 1, properties: dprops });
    }

    return items;
  }

  function getPerso() {
    var store = window.MRP_PERSO;
    var nameEl = document.querySelector('[data-mrp-field="name"]');
    var phoneEl = document.querySelector('[data-mrp-field="phone"]');
    if (!store && !nameEl && !phoneEl) return null;
    var nom = (nameEl ? nameEl.value : (store && store['Prénom']) || '').trim();
    var tel = (phoneEl ? phoneEl.value : (store && store['Téléphone']) || '').trim();
    if (!nom || !tel) return { ok: false, empty: (!nom ? nameEl : phoneEl) };
    return { ok: true, props: { 'Prénom': nom, 'Téléphone': tel } };
  }

  function addToCart(root, cta) {
    var checked = root.querySelector('input[name^="mro_offer_"]:checked');
    var items = checked ? buildItems(checked) : [];
    if (items && items.error) { alert(items.error); return; }
    if (!items || !items.length) { alert('Cette offre n\'est pas encore configurée (produit manquant).'); return; }
    var checkedWrap = checked ? checked.closest('.mro__offer-wrap') : null;
    var hasDual = checkedWrap && checkedWrap.querySelector('[data-mro-dual]');
    var perso = hasDual ? null : getPerso();
    if (perso && !perso.ok) {
      alert('Merci d\'indiquer le prénom du chien et le numéro de téléphone avant d\'ajouter au panier.');
      if (perso.empty) { try { perso.empty.focus(); perso.empty.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {} }
      return;
    }
    if (perso && perso.ok) {
      items.forEach(function (it) { it.properties = Object.assign({}, it.properties || {}, perso.props); });
    }
    var orig = cta.innerHTML;
    cta.disabled = true;
    cta.innerHTML = '<span style="letter-spacing:.1em">Ajout en cours…</span>';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) { cta.disabled = false; cta.innerHTML = orig; alert(data.description || 'Erreur lors de l\'ajout au panier.'); return; }
      cta.innerHTML = '<span style="letter-spacing:.1em">✓ Ajouté !</span>';
      cta.style.background = '#5A7A50';
      if (typeof aovCartDrawerUpdateAndOpen === 'function') aovCartDrawerUpdateAndOpen();
      else if (typeof aovCartDrawerOpen === 'function') aovCartDrawerOpen();
      setTimeout(function () { cta.innerHTML = orig; cta.style.background = ''; cta.disabled = false; }, 2500);
    })
    .catch(function () { cta.disabled = false; cta.innerHTML = orig; alert('Une erreur est survenue. Veuillez réessayer.'); });
  }

  function initRoot(root) {
    if (root.dataset.mroInit) return;
    root.dataset.mroInit = '1';
    startCountdown(root);
    if (!root.querySelector('input[name^="mro_offer_"]:checked')) {
      var first = root.querySelector('input[name^="mro_offer_"]');
      if (first) first.checked = true;
    }
    var cta = root.querySelector('[data-mro-cta]');
    if (cta) cta.addEventListener('click', function () { addToCart(root, cta); });
    function updateTopPerso() {
      var checkedOffer = root.querySelector('input[name^="mro_offer_"]:checked');
      var w = checkedOffer ? checkedOffer.closest('.mro__offer-wrap') : null;
      var isDual = w && w.querySelector('[data-mro-dual]');
      var top = document.querySelector('[data-mrp-root]');
      if (top) top.style.display = isDual ? 'none' : '';
    }
    root.querySelectorAll('input[name^="mro_offer_"]').forEach(function (r) {
      r.addEventListener('change', updateTopPerso);
    });
    updateTopPerso();
    root.querySelectorAll('.mro__perso').forEach(function (p) {
      function upd() {
        var y = p.querySelector('[data-mro-perso-yes]');
        var on = !!(y && y.checked);
        p.classList.toggle('is-on', on);
        var wrap = p.closest('.mro__offer-wrap');
        if (!wrap) return;
        var note = wrap.querySelector('[data-mro-perso-note]');
        if (note) note.hidden = !on;
        var priceEl = wrap.querySelector('.mro__price');
        if (priceEl) {
          if (!priceEl.dataset.mroBase) priceEl.dataset.mroBase = priceEl.textContent.trim();
          var base = priceEl.dataset.mroBase;
          var addCents = parseInt(p.getAttribute('data-mro-perso-add'), 10) || 0;
          if (on && addCents) {
            var num = parseFloat(base.replace(/\s/g, '').replace(/[^0-9,.-]/g, '').replace(',', '.'));
            if (!isNaN(num)) priceEl.textContent = (num + addCents / 100).toFixed(2).replace('.', ',') + ' €';
          } else {
            priceEl.textContent = base;
          }
        }
      }
      p.querySelectorAll('[data-mro-perso-radio]').forEach(function (r) { r.addEventListener('change', upd); });
      upd();
    });
  }

  function init() { document.querySelectorAll('[data-mro-root="v1"]').forEach(initRoot); }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  if (!window.mroBoundV1) { window.mroBoundV1 = true; document.addEventListener('shopify:section:load', init); }
})();
